import React from "react";

const services = [
  { icon: "/assets/ecommerceIcon-WebDevPage.png", title: "E-commerce" },
  { icon: "/assets/entertainmentIcon-WebDevPage.png", title: "Entertainment" },
  { icon: "/assets/uploads/2025/07/PortfolioIcon-WebDevPage.webp", title: "Company Portfolio" },
  { icon: "/assets/marketplaceLogo-webDevPage.png", title: "Market Places" },
  { icon: "/assets/BloggingIcon-WebDevPage.png", title: "Blogging" },
  { icon: "/assets/insuranceIcon-WebDevPage.png", title: "Insurance" },
  { icon: "/assets/CustomPortalIcon-WebDevPage.png", title: "Custom Portals" },
  { icon: "/assets/travelIcon-WebDevPage.png", title: "Travel" },
  { icon: "/assets/SAASProdIcons-WebDevPage.png", title: "SAAS Products" },
  { icon: "/assets/educationIcon-WebDevPage.png", title: "Education, and Beyond" },
];

const Section3 = () => {
  return (
    <div className="container-1280 xl:min-w-[70%]  lg:min-w-[90%] w-[95%] m-auto py-10">
      <div className="grid items-center grid-cols-1 gap-10 md:grid-cols-2">
        <div className="flex flex-col gap-4">
          <h2 className="text-[26px] md:text-[30px] font-bold text-red-600 leading-[28px] md:leading-[34px]">
            Dynamic Websites That Elevate Your Brand
          </h2>
          <p className="text-sm text-gray-700">
            Your website is the cornerstone of your online presence and a powerful tool to connect with audiences worldwide. At Mean3, we specialize in crafting visually stunning, user-friendly, and performance-driven websites tailored to your unique goals.
          </p>
          <p className="text-sm text-gray-700">
            By combining cutting-edge technology with strategic design, we deliver high-performance websites that captivate, convert, and drive growth.
          </p>
          <p className="text-sm font-semibold text-gray-700">
            We extend our services to all kinds of businesses and individuals, including:
          </p>
          <div className="grid justify-center grid-cols-2 gap-4 lg:grid-cols-4">
            {services.map((service, index) => (
              <div key={index} className="flex items-center justify-start gap-2 p-3">
                <img src={service.icon} alt={service.title} className="w-8 h-8" />
                <h3 className="text-xs">{service.title}</h3>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center">
          <img src="../../../../assets/elevateYourBrand-WebDevPage.png" alt="" className="w-[80%]" />
        </div>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </div>
  );
};

export default Section3;
